import type { DeferredMenuDefinition, MenuDefinition } from "@1js/acui-menu";

export const shouldAutoOpenMenu = (
  menuDefinition?: MenuDefinition,
  deferredMenuDefinition?: DeferredMenuDefinition
) => {
  return (
    menuDefinition ??
    (deferredMenuDefinition?.type === "DeferredOverflowMenuDefinition"
      ? deferredMenuDefinition.overflowMenuDefinition
      : deferredMenuDefinition)
  )?.shouldAutoOpen;
};
